import { Component, computed, input } from "@angular/core";
import { NgClass } from "@angular/common";
import { NumberUtils } from "../../utils/number-utils.service";
import { AutoSignificantDigitsPipe } from "../../pipes/number-sig.pipe";

@Component({
  selector: "vl-eur-diff",
  standalone: true,
  imports: [NgClass, AutoSignificantDigitsPipe],
  templateUrl: "./eur-diff.component.html",
  styleUrls: ["./eur-diff.component.scss"],
})
export class EurDiffComponent {
  v = input<number>();
  valeurUnite = input<string>(null);
  redPositive = input<boolean>(true);
  /** Active le formatage `numberSig` (chiffres significatifs, locale fr-FR)
   *  au lieu du `toFixed(2)` historique. Opt-in pour ne pas impacter les
   *  usages existants qui dépendent du 2-décimales fixe. */
  sig = input<boolean>(false);

  vDisplay = computed(() => {
    if (this.v() && !this.valeurUnite()) {
      return NumberUtils.formatMonetaire(this.v());
    }
    if (this.v() && this.valeurUnite()) {
      return NumberUtils.formatNombreReprésentatif(this.v());
    }
  });

  classEcartSurcout = computed(() => {
    if (this.redPositive()) {
      if (this.v() > 0) {
        return "negative";
      }
      if (this.v() < 0) {
        return "positive";
      }
    } else {
      if (this.v() > 0) {
        return "positive";
      }
      if (this.v() < 0) {
        return "negative";
      }
    }
  });
}
